import React, { ReactElement } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import cn from 'classnames';
import styles from './TextArea.module.scss';

export interface TextAreaProps {
  placeholder?: string;
  name: string;
  register: UseFormRegisterReturn<string>;
  errorMessage?: string;
  classname?: string;
  children?: React.ReactElement;
  isRequired?: boolean;
  label?: string;
  inputStyle?: 'clasic' | 'compressed' | 'ultra-compressed';
}

export const TextArea: React.FC<TextAreaProps> = ({
  placeholder,
  name,
  register,
  errorMessage,
  classname,
  children,
  isRequired,
  label = undefined,
  inputStyle,
}) => {
  return (
    <div
      className={cn(
        styles.root,
        errorMessage ? styles.error : undefined,
        styles[inputStyle],
        classname
      )}
    >
      {label && (
        <label htmlFor={name}>
          {label}
          {isRequired && <span className={styles.required}>*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        {...register}
        placeholder={placeholder}
        style={{}}
      />
      {children && children}
      {errorMessage && <span>{errorMessage as unknown as ReactElement}</span>}
    </div>
  );
};
